if (process.env && process.env.NODE_ENV === 'production') {
  __webpack_public_path__ = window.__webpack_public_path__;
}

import { merge } from 'lodash-es';
import { picoapp } from 'picoapp';

import { AppComponents } from './AppComponents';
import { AppViews } from './AppViews';
import { AppState } from './AppState';
import common from './features/common';
//import webfonts from './features/webfonts';
import icons from './features/icons';

const components = merge(AppComponents, AppViews);
const app = picoapp(components, AppState);

window.theme_app = app;

app.mount(['data-component', 'data-template']);

common.init(app);
//webfonts.init();
icons.init();